import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import userData from "./features/UserDataslice";
import filterReducer from "./features/filterSlice";

const initialAuthState = {
  loginName: null,
  userId: null,
  orgdbName: "",
  serverip: "",
  dbusername: "",
  dbpassword: "",
dbid:"",
orgname:"",
  remember: false,
};

const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case "auth/setAuth":
      return { ...state, ...action.payload };
    case "auth/clearAuth":
      return initialAuthState;
    case "auth/setOrgDbName":
      return { ...state, orgdbName: action.payload };
    default:
      return state;
  }
};

const appReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  userData: userData,
  filter: filterReducer,
});


const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined;  
  }
  return appReducer(state, action);
};

export default rootReducer;
